import API from './api';

export default class LoginHistory extends API {}
